import React from 'react';

function SkeletonBar({ className = '' }: { className?: string }) {
    return (
        <div className={`animate-pulse rounded bg-gray-200 dark:bg-gray-700 ${className}`} />
    );
}

/** Full-page placeholder while a standalone change URL is loading. */
function ChangeStandaloneSkeleton() {
    return (
        <div
            className="relative flex h-full min-h-0 w-full flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow dark:border-gray-600 dark:bg-gray-700"
            data-testid="change-standalone-skeleton"
            aria-busy="true"
            aria-live="polite"
        >
            <div className="flex w-full items-start justify-between gap-4 border-b p-5 dark:border-gray-600">
                <div className="min-w-0 flex-1 space-y-3">
                    <div className="flex flex-wrap items-center gap-2">
                        <SkeletonBar className="h-7 w-16" />
                        <SkeletonBar className="h-5 w-24" />
                        <SkeletonBar className="h-5 w-20" />
                    </div>
                    <SkeletonBar className="h-7 w-3/4 max-w-xl" />
                    <div className="flex flex-wrap gap-2">
                        <SkeletonBar className="h-6 w-28" />
                        <SkeletonBar className="h-6 w-24" />
                        <SkeletonBar className="h-6 w-20" />
                    </div>
                </div>
                <SkeletonBar className="h-8 w-8 shrink-0" />
            </div>
            <div className="grid flex-1 grid-cols-1 gap-6 p-6 lg:grid-cols-3">
                <div className="space-y-4 lg:col-span-2">
                    <SkeletonBar className="h-4 w-32" />
                    <SkeletonBar className="h-4 w-full" />
                    <SkeletonBar className="h-4 w-11/12" />
                    <SkeletonBar className="h-4 w-4/5" />
                    <SkeletonBar className="mt-6 h-4 w-40" />
                    <SkeletonBar className="h-24 w-full" />
                    <SkeletonBar className="h-16 w-full" />
                </div>
                <div className="space-y-3">
                    <SkeletonBar className="h-24 w-full" />
                    <SkeletonBar className="h-24 w-full" />
                    <SkeletonBar className="h-32 w-full" />
                </div>
            </div>
        </div>
    );
}

export default ChangeStandaloneSkeleton;
